import { store } from '@/store';
import axios from 'axios';

export default function(params = {}) {
    // Create Axios object.
    params.baseURL = `${process.env.VUE_APP_API_URL}`;
    params.timeout = 60000; // 30 seconds.
    params.headers = {
        'Authorization': `Bearer ${store.getters.apiKey}`,
        'Accept-Language': store.getters.lang,
        'Content-Type': 'application/json',
    };
    let api = axios.create(params);

    // Global response handler.
    api.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        if (error.response && error.response.status === 401) {
            // Handle unauthorized request.
            let route = window.router.currentRoute.name;
            if (error.response.data.message === 'mfa.required') {
                if (route !== 'mfa') window.router.push({ name: 'mfa' });
                return new Promise(() => {});
            } else {
                store.commit('logout');
                if (route !== 'login') window.router.push({ name: 'login' });
                return new Promise(() => {});
            }
        } else {
            return Promise.reject(error);
        }
    });

    return api;
}
